var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-element-badge",style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.value.label || "missing badge label")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }